<template>
  <div
    class="mx-auto d-flex flex-column"
    style="border-radius: 20px; height: 80vh"
  >
    <div style="height: calc(100% - 60px)">
        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

      <v-expand-transition mode="out-in">
        <div
          v-if="mainPage"
          key="main"
          class="custom-scrollbar main-wrapper positon-relative"
        >
          <!-- Welcome Screen - Only show if welcome is active -->
          <component
            :is="componentsScale[value?.photo?.transition || 'scale']"
            mode="out-in"
            origin="center"
          >
            <div
              v-if="showWelcome && value.photo?.welcome"
              key="welcome"
              class="col-md-11 mx-auto d-flex"
              style="min-height: 75vh"
            >
              <div
                v-if="
                  value.photo.welcome === '' || value.photo.welcome === null
                "
                class="col m-auto"
              >
                <atom-spinner
                  :animation-duration="1000"
                  :size="80"
                  class="mx-auto justify-content-center"
                  color="#ff1d5e"
                />
              </div>

              <div v-else class="m-auto">
                <img
                  :src="value.photo.welcome"
                  alt=""
                  class="bg-white img-fluid rounded-circle mx-auto my-auto"
                  width="100"
                />
              </div>
            </div>
          </component>

          <!--previewer -->
          <component
            :is="
              componentsScale[value?.photo?.previewerQr?.transition || 'scale']
            "
            mode="out-in"
            origin="center"
          >
            <!-- previewerQr Screen - GIF Preview -->
            <div
              v-if="showPreviewer && value.photo.previewerQr.previewer.gif"
              key="gif-preview"
              class="col-md-11 mx-auto d-flex"
              style="min-height: 75vh; display: flex !important"
            >
              <div class="m-auto position-relative" style="max-width: 240px">
                <v-btn
                  class="position-absolute top-0 start-0 ms-2 mt-2"
                  color="error"
                  icon
                  @click="showPreviewer = false"
                  style="
                    z-index: 10;
                    background: rgba(255, 255, 255, 0.8);
                    border-radius: 50%;
                  "
                >
                  <v-icon size="24">mdi-close</v-icon>
                </v-btn>
                <v-img
                  :src="value.photo.previewerQr.previewer.gif"
                  alt="خوش آمدگویی"
                  class="bg-white img-fluid mx-auto my-auto"
                  width="240"
                  :style="{
                    borderRadius: `${
                      value.photo.previewerQr.gifBorderRadius || 0
                    }px`,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                    objectFit: 'contain',
                  }"
                />
              </div>
            </div>
          </component>
          <!-- Show assistant chat if available -->
          <assistant-chat-viewer
            v-if="
              !!value.advanceSettings?.hasAssistants &&
              !!value.advanceSettings?.aiChatConfig?.assistantId
            "
            :aiChatConfig="value.advanceSettings.aiChatConfig"
          />

          <!-- Show main content only when no welcome preview is active -->
          <div
            v-if="!(showWelcome || showPreviewer || showPreviewDialog)"
            class="main-content-container"
          >
            <div
              :style="{ background: value?.pallete?.headColor }"
              class="head-img rounded-lg position-sticky pa-0"
              style="top: 0; z-index: 2"
            >
              <v-img
                :aspect-ratio="16 / 9"
                :src="getHeaderImg"
                class="rounded-lg"
                max-width="100%"
              />
              <v-btn
                v-if="$route.name.toLowerCase().includes('productpro')"
                color="rgba(255, 255, 255, 0.9)"
                fab
                x-small
                absolute
                bottom
                left
                class="ms-4 mb-4 shadow-btn"
                style="bottom: 10px; left: 10px; z-index: 10"
                @click="sizeSheet = !sizeSheet"
              >
                <v-icon :color="sizeSheet ? 'error' : 'primary'" size="20">
                  {{ sizeSheet ? "mdi-close" : "mdi-tune-variant" }}
                </v-icon>
              </v-btn>
            </div>

            <div
              v-if="$route.name.toLowerCase().includes('productpro')"
              class="size-menu-wrapper position-sticky"
              style="top: 16px; z-index: 3; width: 100%; text-align: center"
            >
            <v-expand-transition>
              <div v-show="sizeSheet" class="inner-settings-panel pa-4">
                <div class="d-flex align-center mb-3">
                  <span class="text-caption font-weight-bold grey--text text--darken-2"
                    >تنظیم چیدمان کارت‌ها</span
                  >
                  <v-divider class="ms-3"></v-divider>
                </div>

                <v-btn-toggle
                  v-model="value.cardSettings.sizeLevel"
                  mandatory
                  borderless
                  class="size-grid-internal"
                >
                  <v-btn
                    v-for="item in gridOptions"
                    :key="item.value"
                    :value="item.value"
                    fab
                    depressed
                    x-small
                    class="size-mini-btn"
                    :style="
                      value.cardSettings.sizeLevel === item.value
                        ? {
                            background: value.pallete.bodyColor,
                            color: value.pallete.textColor,
                            transform: 'scale(1.1)',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                          }
                        : {}
                    "
                  >
                    <v-icon :size="item.size">{{ item.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-expand-transition>

            </div>

            <v-row
              class="justify-center custom-scrollbar py-2"
              no-gutters
              align="center"
            >
              <draggable
                v-model="allowRender"
                v-bind="dragOptions"
                tag="div"
                class="d-flex flex-wrap w-100 px-2"
                handle=".drag-handle"
              >
                <transition-group
                  name="menu-flip"
                  tag="div"
                  class="d-flex flex-wrap w-100"
                >
                  <v-col
                    v-for="(item, index) in allowRender"
                    :key="item.name"
                    cols="6"
                    class="pl-1 pb-1 pr-0 pt-0 ma-0"
                    :class="
                      effectiveSizeLevel > 4
                        ? 'd-flex flex-column justify-content-center align-items-center '
                        : effectiveSizeLevel <= 4 && effectiveSizeLevel > 2
                        ? index % 2 === 0
                          ? 'd-flex flex-column justify-content-center align-items-end'
                          : 'd-flex flex-column justify-content-center align-items-start'
                        : ''
                    "
                  >
                    <v-hover v-slot="{ hover }">
                      <div
                        :style="cardStyle(item, hover, index)"
                        :class="[
                          'card menu-item text-center position-relative',
                          cardSizeClass,
                          index % 2 === 0 ? 'rectangels' : 'rectangels-left',
                          effectiveSizeLevel === 4 ? 'card-size-4' : '',
                          effectiveSizeLevel === 5 ? 'card-size-5' : '',
                        ]"
                        @click="activeSection(item.name)"
                      >
                        <v-icon
                          x-small
                          class="drag-handle position-absolute"
                          style="top: 6px; right: 6px; cursor: grab"
                          :color="hover ? value?.pallete?.textColor : 'black'"
                        >
                          mdi-dots-grid
                        </v-icon>

                        <span>
                          <v-icon
                            v-if="!item?.src"
                            :color="
                              hover
                                ? value.cardSettings.iconColorHover ||
                                  value?.pallete?.textColor
                                : value.cardSettings.iconColor || 'black'
                            "
                            :size="iconSize"
                          >
                            mdi-{{ item.icon }}
                          </v-icon>
                          <img
                            v-if="item?.src"
                            :src="item.src"
                            :width="effectiveIconSize"
                            :height="effectiveIconSize"
                            class="product-gif"
                            style="object-fit: contain"
                          />
                        </span>
                        <p
                          :style="{
                            color: hover ? value.pallete.textColor : 'black',
                            fontSize: effectiveLabelFontSize,
                            lineHeight: '1.3',
                            marginTop: '8px',
                          }"
                          class="mb-0 text-center"
                        >
                          {{ item.secondName }}
                        </p>
                      </div>
                    </v-hover>
                  </v-col>
                </transition-group>
              </draggable>
            </v-row>
          </div>
          <!-- Close the main content container -->
        </div>
        <!-- Close the conditional wrapper for main content -->

        <div
          v-else
          key="info"
          :style="{
            background: value?.photo?.headBackground
              ? `linear-gradient(to bottom, rgba(250, 245, 245,.79), rgba(250, 245, 245,.79)), url(${value?.photo?.headBackground})`
              : value?.pallete?.bodyColor,
          }"
          class="p-content-wrapper overflow-hidden"
        >
          <div
            v-if="boxName === 'factoryInfo'"
            class="col-md-12 pb-0"
            style="overflow-y: auto; max-height: 100%"
          >
            <profile-photos v-model="value.photo" class="float-left col-12" />
            <h3 class="text-center my-1">{{ value?.organizationName }}</h3>
            <h6 class="text-center my-1">{{ value?.subOrgan }}</h6>
            <pre class="text-right mt-2 mb-0" v-html="trancateTxts" />
            <v-btn
              v-if="
                value?.aboutUs?.length > 200 ||
                value?.aboutUs?.split('<div>').length > 3
              "
              class="ms-n4"
              color="primary"
              text
              @click="isTruncate = !isTruncate"
            >
              {{ isTruncate ? "مشاهده بیشتر" : "مشاهده کمتر" }}
            </v-btn>
            <extra-shown
              v-model="value.extraFields"
              :has-class="true"
              font-color="black"
            />
            <numbers-show v-model="value" font-color="black" />
          </div>

          <div v-if="boxName === 'FeedBack'">
            <b-feedback-view
              :style="{
                background: value.pallete.bodyColor,
                color: value.pallete.textColor,
              }"
              v-if="value.FeedBack && value.FeedBack.items.length > 0"
              v-model="value.FeedBack"
            />
          </div>
          <div v-if="boxName === 'consultationNew'">
            <consultation-new-show
              :style="{
                background: value.pallete.bodyColor,
                color: value.pallete.textColor,
              }"
              :color="value.pallete.textColor"
              v-model="value.consultationNew"
            />
          </div>

          <div v-if="boxName === 'Features'" class="col-md-12 p-0 fill-height">
            <second-page
              v-model="value.Features.details"
              :bg="value?.pallete"
            />
          </div>

          <div
            v-if="boxName === 'imageUploader'"
            class="col-md-12 custom-scrollbar"
            style="max-height: 100%; overflow-y: auto"
          >
            <image-slider v-model="value.photo.gallery" />
          </div>

          <div
            v-if="boxName === 'VideoGallery'"
            class="col-md-12 pt-0 mt-0"
            style="max-height: 500px; overflow-y: auto"
          >
            <b-gallery-view
              v-if="
                value &&
                value?.VideoGallery &&
                value?.VideoGallery?.sectionColor
              "
              v-model="value.video_gallery"
              :description="value?.VideoGallery?.description"
              :is-img="false"
              :style="{
                background: value?.VideoGallery?.sectionColor?.backGround,
                color: value?.VideoGallery?.sectionColor?.text,
              }"
              :title="value?.VideoGallery?.title"
              type="video_gallery"
            />
          </div>

          <div
            v-if="boxName === 'singleProductEditor'"
            class="pa-5 custom-scrollbar"
            style="max-height: 100%; overflow-y: auto"
          >
            <div class="o-card_body">
              <h2 class="o-card_title">{{ value?.singleProduct?.name }}</h2>
            </div>
            <p
              v-if="value?.singleProduct?.price"
              :style="{ color: 'black' }"
              class="text-right mt-4"
            >
              <span class="font-weight-bold"> <span>قیمت</span> : </span>
              <span
                :style="{
                  'text-decoration-line': value?.singleProduct?.discount
                    ? 'line-through'
                    : '',
                  color: 'black',
                }"
              >
                {{ value?.singleProduct?.price | currency | persianNum }}
                ﷼</span
              >
              <span
                v-if="computePrice"
                :style="{ color: 'black' }"
                class="font-weight-bold float-end mr-10"
              >
                {{ computePrice | currency | persianNum }} ﷼
              </span>
            </p>

            <v-btn
              v-if="!!btnSetting"
              :href="btnSetting.link"
              :style="{
                background: btnSetting.background,
                color: btnSetting.color,
              }"
              target="_blank"
            >
              <v-icon v-if="!!btnSetting.icon" left>{{
                btnSetting.icon
              }}</v-icon>
              {{ btnSetting.title }}
            </v-btn>

            <pre class="text-right mt-2 mb-0" v-html="trancateTxts1" />
            <v-btn
              v-if="
                value?.singleProduct?.description?.length > 200 ||
                value?.singleProduct?.description?.split('<div>').length > 3
              "
              class="ms-n4"
              color="primary"
              text
              @click="isTruncate1 = !isTruncate1"
            >
              {{ isTruncate1 ? "مشاهده بیشتر" : "مشاهده کمتر" }}
            </v-btn>

            <v-img
              v-if="value?.singleProduct?.image"
              :src="value.singleProduct.image"
              class="rounded-lg ma-2"
              contain
            />
            <v-card-actions
              v-if="!!value?.singleProduct && !!value?.singleProduct?.payLink"
              class="mb-2"
            >
              <v-btn
                :href="value.singleProduct.payLink"
                :style="{
                  background: value.singleProduct.btnSetting.background,
                  color: value.singleProduct.btnSetting.color,
                }"
                target="_blank"
              >
                <v-icon
                  v-if="value?.singleProduct?.btnSetting?.icon"
                  class="ml-2"
                  >{{ value.singleProduct.btnSetting.icon }}
                </v-icon>
                {{ value.singleProduct.btnSetting.title }}
              </v-btn>
            </v-card-actions>

            <template v-if="hasExtra">
              <v-divider />
              <v-card-title class="pa-0">سایر ویژگی‌ها</v-card-title>
              <extra-shown v-model="value.singleProduct.extra" />
              <v-divider />
            </template>

            <certificates-view v-model="value.singleProduct.arm" />
          </div>

          <div
            v-if="boxName === 'socialMediaIcons'"
            class="col-md-12 d-flex justify-center align-center fill-height social-icons-wrapper flex-wrap custom-scrollbar"
            style="max-height: 100%; overflow-y: auto"
          >
            <div
              v-for="(item, index) in computeFields"
              :key="index"
              class="pa-2 text-center"
            >
              <v-card
                :style="{ background: value.pallete.headColor }"
                class="rounded-circle d-flex align-center justify-center pa-1 mx-auto"
                flat
                height="64"
                link
                width="64"
                @click="goToUrl(item.url, item.pattern)"
              >
                <img
                  :src="item.img"
                  alt=""
                  class="social-img"
                  style="object-fit: contain; max-width: 40px"
                />
              </v-card>
            </div>
          </div>

          <div v-if="value?.coordinates && boxName === 'location'" class="pa-2">
            <v-card-title class="px-0 pt-0 justify-end">
              <v-btn
                class="mx-2 mr-auto text-left"
                color="white"
                small
                @click="mainPage = true"
              >
                بازگشت
                <v-icon class="ms-2" color="black"
                  >mdi-keyboard-backspace</v-icon
                >
              </v-btn>
            </v-card-title>
            <map-show v-if="!mainPage" v-model="value" />
          </div>

          <div
            v-if="
              value?.audiosGallery?.audios?.length > 0 &&
              boxName === 'voiceGallery'
            "
            class="pa-2"
            style="height: 100%; overflow-y: auto; overflow-x: hidden"
          >
            <v-card-title>گالری فایل صوتی</v-card-title>
            <v-row class="d-flex flex-column align-items-center">
              <v-col
                cols="12"
                v-for="(audio, i) in value.audiosGallery.audios"
                :key="i"
                class="d-flex flex-column align-items-center"
              >
                <v-card
                  :style="{ background: audio?.background ?? 'transparent' }"
                  width="300"
                  class="d-flex align-items-center justify-content-center flex-column"
                >
                  <v-card-title v-if="audio?.ti?.length > 0">{{
                    audio?.ti
                  }}</v-card-title>
                  <v-card-subtitle class="pa-0" v-if="audio?.desc?.length">{{
                    audio?.desc
                  }}</v-card-subtitle>
                  <component
                    :is="value.audiosGallery.audioType"
                    :file="audio.full_path"
                    :link="false"
                    :inf="{
                      ti: audio?.ti,
                      link: audio?.link,
                      title: audio?.title,
                      desc: audio?.desc,
                    }"
                    :image="audio?.image"
                    :title="audio.title.length > 0 ? audio.title : 'فایل صوتی'"
                    width="100%"
                    :height="
                      value.audiosGallery.audioType == 'newPlayer' ? 280 : 150
                    "
                    :flat="true"
                    :audioSound="false"
                    :color="audio?.color"
                    background="transparent"
                  />
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-expand-transition>
    </div>

    <div
      v-if="
        !value.photo.hasWelcome ||
        (value.photo.hasWelcome &&
          !(showWelcome || showPreviewer || showGameModal || showPreviewDialog))
      "
      :style="{ background: value.pallete.headColor }"
      class="d-flex align-center position-relative p-footer-wrapper"
    >
      <div class="footer-home-btn">
        <v-btn
          icon
          rounded
          style="background-color: white"
          x-large
          @click="mainPage = true"
        >
          <v-icon
            :color="value.pallete.textColor"
            :style="{ background: value.pallete.headColor, zIndex: 11 }"
            class="p-6 rounded-circle"
          >
            mdi-home
          </v-icon>
        </v-btn>
      </div>
      <div class="px-8 d-flex align-center justify-space-between flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2" dark fab icon small v-bind="attrs" v-on="on">
              <v-icon :color="value.pallete.textColor"
                >mdi-card-account-phone-outline</v-icon
              >
            </v-btn>
          </template>

          <span>باشگاه مشتریان</span>
        </v-tooltip>
        <!--        <v-btn icon style="z-index: 2" @click="activeSection('location')">-->
        <!--          <v-icon :color="value.pallete.textColor" size="30">mdi-map-marker</v-icon>-->
        <!--        </v-btn>-->

        <v-btn class="float-left" icon style="z-index: 2" @click="getVcf">
          <v-icon :color="value.pallete.textColor" size="30"> mdi-plus </v-icon>
        </v-btn>
      </div>
    </div>
    <game-modal
      v-if="showGameModal"
      v-model="showGameModal"
      :game="selectedGame"
      @close="showGameModal = false"
      class="contained-game-modal"
    />
    <!-- nدیالوگ بازی عمومی پیش‌نمایش -->
    <PhoneFrame
      v-model="showPreviewDialog"
      v-if="showPreviewDialog"
      :background-image="
        value.photo?.previewerQr?.previewer?.game?.config?.images
          ?.phoneFrameBackground
      "
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
      "
    >
      <Game
        :key="previewKey"
        v-if="showPreviewDialog && gameName === 'Game'"
        :value="value.photo.previewerQr.previewer.game.config"
        @gameover="onPreviewGameOver"
        @submit-score="onGameScoreSubmit"
      />
      <MeepMeepProRunner
        v-if="showPreviewDialog && gameName === 'MeepMeepProRunner'"
        :value="value.photo.previewerQr.previewer.game.config"
        @submit-score="onGameScoreSubmit"
      />
    </PhoneFrame>
  </div>
</template>

<script>
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";

import PhoneFrame from "@/view/components/game/publicGame/phoneFrame";
import Game from "@/view/components/game/publicGame/game";
import MeepMeepProRunner from "@/view/components/game/publicGame/MeepMeepProRunner";
import gameModal from "@/view/components/game/gameModal.vue";
import draggable from "vuedraggable";
import SecondPage from "@/view/pages/product/secondPage";
import NumbersShow from "@/view/pages/product/numbersShow";
import ImageSlider from "@/view/components/Gallery/imageSlider";
import ExtraShown from "@/view/components/Product/extraShown";
import MapShow from "@/view/components/Product/mapShow";
import axios from "axios";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import ProfilePhotos from "@/view/components/repeatitive/profilePhotos";
import CertificatesView from "./certificatesView";
import audioPlayerCard from "../../components/UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer2 from "../../components/UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
import newPlayer from "../../components/UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView.vue";
import consultationNewShow from "@/view/components/consultationNew/consultationNewShow.vue";
import assistantChatViewer from "@/view/pages/qrland/components/assistantChatViewer.vue";
import { Bus } from "../../../main";
import UniversalQrModal from "../../components/UniversalQrModal.vue";
export default {
  name: "newDesign",

  components: {
    draggable,
    CertificatesView,
    ProfilePhotos,
    BGalleryView,
    MapShow,
    ExtraShown,
    ImageSlider,
    NumbersShow,
    SecondPage,
    audioPlayerCard,
    newPlayer2,
    newPlayer,
    BFeedbackView,
    consultationNewShow,
    assistantChatViewer,
    gameModal,
    PhoneFrame,
    Game,
    MeepMeepProRunner,
    VFadeTransition,
    VScaleTransition,
    VSlideXTransition,
    VSlideYTransition,
    UniversalQrModal
  },

  props: {
    value: { type: Object, default: () => ({}) },
    components: Array,
    ordered: {
      type: Array,
      default: () => [],
    },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data() {
    return {
    showQrDialog: false,
     gridOptions: [
      { value: 1, icon: 'mdi-square',    size: 24 }, 
      { value: 2, icon: 'mdi-view-grid', size: 24 }, 
      { value: 3, icon: 'mdi-view-module',size: 24 }, 
      { value: 4, icon: 'mdi-apps',       size: 24 }, 
      { value: 5, icon: 'mdi-view-comfy', size: 24 }, 
      { value: 6, icon: 'mdi-view-comfy', size: 20 }, 
      { value: 7, icon: 'mdi-view-comfy', size: 16 }, 
      { value: 8, icon: 'mdi-view-comfy', size: 12 }, 
    ],
      sizeSheet: false,
      showWelcome: false,
      showPreviewer: false,
      locationPage: false,
      showPreviewDialog: false,
      gameName: "",
      previewKey: Date.now(),
      showGameModal: false,
      selectedGame: null,
      tab: "option-1",
      allowRender: [],
      showInfo: "",
      mainPage: true,
      isTruncate: true,
      isTruncate1: true,
      boxName: "",
      componentsScale: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
  beforeDestroy() {
    Bus.$off("preview-game-in-mobile");
    Bus.$off("open-game-modal");
    Bus.$off("showMe");
    Bus.$off("showPreviewer");
  },
  created() {
    if (!this.value.cardSettings) {
      this.$set(this.value, "cardSettings", {
        sizeLevel: 1,
        // iconColor: "#1CFA1C",
        // iconColorHover: null,
      });
    }
  },
  mounted() {
    this.componentsGenerator();
    Bus.$on("preview-game-in-mobile", (payload) => {
      this.selectedGame = payload.game;
      this.showGameModal = true;
    });
    Bus.$on("open-game-modal", (payload) => {
      this.selectedGame = payload.game;
      if (this.selectedGame.type === "private") {
        this.showGameModal = true;
        this.gameName = payload.game.name;
      } else {
        this.showPreviewDialog = true;
        this.gameName = payload.game.name;
      }
      this.$forceUpdate();
    });
    Bus.$on("showMe", (value) => {
      console.log(this.value?.photo.hasWelcome, "this.value?.photo.hasWelcome");
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        console.log(
          this.value?.photo.hasWelcome,
          "this.value?.photo.hasWelcome2",
        );

        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 3000);
      }
    });
    Bus.$on("showPreviewer", (value) => {
      if (this.value?.photo?.previewerQr.previewer.gif) {
        this.showPreviewer = true;
        this.locationPage = false;
        this.showWelcome = false;

        setTimeout(() => {
          this.locationPage = false;
          // this.showPreviewer = false;
          this.showWelcome = false;
        }, 3000);
      }
    });
  },

  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    colsPerCard() {
      const level = this.effectiveSizeLevel || 1;

      if (level <= 2) return 6;
      if (level <= 6) return 6;
      return 4;
    },

    gapClass() {
      const level = this.effectiveSizeLevel || 1;
      if (level >= 7) return "pa-2";
      if (level >= 3) return "pa-3";
      return "pa-4";
    },
    effectiveSizeLevel() {
      return this.value?.cardSettings?.sizeLevel ?? 1;
    },

    effectiveIconSize() {
      const map = [55, 50, 44, 38, 32, 30, 28, 26];
      return map[this.effectiveSizeLevel - 1] || 55;
    },
    effectiveCardPadding() {
      const map = [
        "20px 16px", // 1
        "14px 10px", // 2
        "10px 8px", // 3
        "8px 6px", // 4
        "6px 4px", // 5
        "6px 4px", // 6
        "4px 3px", // 7
        "3px 2px", // 8
      ];
      return map[this.effectiveSizeLevel - 1] || "20px 16px";
    },

    effectiveMinHeight() {
      const map = [120, 110, 100, 50, 50, 45, 40, 36];
      return map[this.effectiveSizeLevel - 1] || 120;
    },
    effectiveLabelFontSize() {
      const map = [
        "1rem",
        "0.95rem",
        "0.9rem",
        "0.85rem",
        "0.82rem",
        "0.8rem",
        "0.78rem",
        "0.75rem",
      ];
      return map[this.effectiveSizeLevel - 1] || "1rem";
    },
    effectiveScaleFactor() {
      const map = [1.0, 1.0, 1.0, 0.98, 0.96, 0.94, 0.9, 0.85, 0.8, 0.75];
      return map[this.effectiveSizeLevel - 1] || 1;
    },
    effectiveCardMargin() {
      const map = ["2px", "2px", "2px", "2px", "2px", "2px", "2px", "2px"];
      return map[this.effectiveSizeLevel - 1] || "2px";
    },
    cardClasses() {
      return {
        "size-1": this.size === 1,
        "size-2": this.size === 2,
        "size-3": this.size === 3,
        "size-4": this.size === 4,
        "size-5": this.size === 5,
      };
    },

    labelFontSize() {
      const sizes = {
        1: "1rem",
        2: "0.95rem",
        3: "0.9rem",
        4: "0.85rem",
        5: "0.8rem",
      };
      return sizes[this.size] || "1rem";
    },

    cardSizeClass() {
      return `card-size-${this.size}`;
    },

    effectiveSizeLevel() {
      return this.value?.cardSettings?.sizeLevel ?? 1;
    },

    iconSize() {
      const map = { 1: 55, 2: 50, 3: 44, 4: 38, 5: 32 };
      return map[this.effectiveSizeLevel] || 55;
    },
    columnSize() {
      const map = { 1: 5, 2: 5, 3: 5, 4: 5, 5: 5 };
      return map[this.size] || 5;
    },
    rowSpacingClasses() {
      const map = {
        1: "py-3",
        2: "py-2",
        3: "py-2",
        4: "py-1",
        5: "py-1",
        6: "py-1",
        7: "py-1",
        8: "py-1",
      };
      return map[this.size] || "py-3";
    },
    colSpacingClasses() {
      const map = {
        1: "mt-9 ml-1",
        2: "mt-7 ml-1",
        3: "mt-6 ml-1",
        4: "mt-4 ml-1",
        5: "mt-3 ml-1",
        6: "mt-6 ml-1",
        7: "mt-4 ml-1",
        8: "mt-3 ml-1",
      };
      return map[this.size] || "mt-9 ml-1";
    },

    cardPadding() {
      const map = {
        1: "20px 16px",
        2: "12px",
        3: "10px",
        4: "8px",
        5: "6px",
        6: "3px",
        7: "2px",
        8: "2px",
      };
      return map[this.effectiveSizeLevel] || "20px 16px";
    },

    cardMinHeight() {
      const map = { 1: 120, 2: 105, 3: 92, 4: 80, 5: 68, 6: 96, 7: 50, 8: 50 };
      return map[this.effectiveSizeLevel] || 120;
    },

    scaleFactor() {
      const map = {
        1: 1,
        2: 1,
        3: 0.92,
        4: 0.78,
        5: 0.68,
        6: 0.65,
        7: 0.6,
        8: 0.55,
      };
      return map[this.effectiveSizeLevel] || 1;
    },
    computedAllowRender: {
      get() {
        return this.allowRender;
      },
      set(newVal) {
        if (!this.components || !Array.isArray(newVal) || newVal.length === 0)
          return;
        const allowedNames = new Set(newVal.map((i) => i.name));
        const ordered = [];
        const allowedOrder = newVal.slice();
        let j = 0;
        for (const c of this.components) {
          if (allowedNames.has(c.name)) {
            ordered.push(allowedOrder[j++]);
          } else {
            ordered.push(c);
          }
        }
        const renderingOrder = this.allowRender.map((item) => item.name);
        this.$emit("update:components", ordered);
        this.$emit("update:changeOrder", renderingOrder);
      },
    },

    dragOptions() {
      return {
        animation: 220,
        ghostClass: "menu-ghost",
        chosenClass: "menu-chosen",
        dragClass: "menu-drag",
        forceFallback: true,
      };
    },

    getHeaderImg() {
      return this.value.photo.background ?? "";
    },
    computePrice() {
      if (this.value.singleProduct.discount) {
        const percent =
          (this.value.singleProduct.price * this.value.singleProduct.discount) /
          100;
        return this.value.singleProduct.price - percent;
      } else return false;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value.socialMedia).forEach(([x, y]) => {
        extra.push(...y);
      });

      return extra;
    },
    trancateTxts() {
      let about = this.value.aboutUs;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    trancateTxts1() {
      let about = this.value.singleProduct.description;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate1
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    btnSetting() {
      return this.value.singleProduct?.btnSetting?.show
        ? this.value.singleProduct.btnSetting
        : false;
    },
    hasExtra() {
      return !!this.value.singleProduct?.extra?.some((item) => {
        delete item.type;
        return !!Object.values(item).some((s) => !!s);
      });
    },
  },

  watch: {
    value: {
      deep: true,
      handler(val) {
        this.componentsGenerator();
      },
    },
    allowRender: {
      deep: true,
      handler() {
        const renderingOrder = this.allowRender.map((item) => item.name);
        this.$emit("update:ordered", renderingOrder);
      },
    },
  },
  methods: {
    cardStyle(item, hover, index) {
      const level = this.effectiveSizeLevel;

      return {
        transform: hover
          ? index % 2 === 0
            ? "translateY(30px)"
            : "translateY(-5px)"
          : index % 2 === 0
          ? "translateY(35px)"
          : "none",
        boxShadow: hover
          ? "0 9px 10px rgba(0, 0, 0, 0.15), 0 4px 6px rgba(49, 48, 48, 0.2)"
          : "0 4px 6px rgba(0, 0, 0, 0.02)",
        zIndex: hover ? 10 : 1,
        padding: this.cardPadding,
        minHeight: `${this.cardMinHeight}px`,
        margin: this.effectiveCardMargin + " !important",
        background: hover ? this.value.pallete.bodyColor : "#ebeff2",
        color: !hover ? "black" : this.value.pallete.textColor,
        zoom: this.size >= 3 ? `${this.scaleFactor}` : null,
        width: `${this.scaleFactor * 100}% !important`,
        height: `auto`,
        // aspectRatio: `16/9`,
        transformOrigin: "center",
        transition: "all 0.3s ease",
        display: "flex !important",
        flexDirection: "column !important",
        justifyContent: "center !important",
        alignItems: "center !imprtant",
        // borderRadius: level <= 3 ? "25px" : "16px",
      };
    },

    onPreviewGameOver(score) {
      console.log("Preview game over, score:", score);
    },
    onGameScoreSubmit(data) {
      console.log("Game score submitted:", data);
    },
    showPreview() {
      this.previewKey = Date.now();
      this.showPreviewDialog = true;
    },

    componentsGenerator() {
      let allowed = this.components.filter((item) => {
        return ![
          "colorPallete",
          "customerClubSettings",
          "advanceSettings",
        ].includes(item.name);
      });
      if (this.ordered && this.ordered.length > 0) {
        const sorted = [];
        const remaining = [];
        this.ordered.forEach((name) => {
          const found = allowed.find((item) => item.name === name);
          if (found) {
            sorted.push(found);
          }
        });

        allowed.forEach((item) => {
          if (!this.ordered.includes(item.name)) {
            remaining.push(item);
          }
        });

        this.allowRender = [...sorted, ...remaining];
      } else {
        this.allowRender = allowed;
      }
    },
    activeVideo() {
      var leng = [];
      this.value.video_gallery.map((item) => {
        if (item.images.length > 0) {
          leng.push(false);
        }
      });

      console.log(leng);

      return leng;
    },
    activeSection(name) {
      this.boxName = name;
      this.mainPage = false;
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.userName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.main-wrapper {
  max-height: 100%;
  overflow-y: visible;
  overflow-x: hidden;
}

.head-img {
  border-radius: 20px 20px 0 0;
}

.p-content-wrapper {
  background-position: center !important;
  background-repeat: no-repeat !important;
  border-radius: 20px 20px 0 0;
  background-size: cover !important;
  height: 100%;
}

.p-footer-wrapper {
  border-radius: 0px 0px 20px 20px;
  min-height: 60px;
}

.footer-home-btn {
  position: absolute;
  top: -20px;
  z-index: 12;
  transform: translateX(-50%);
  left: 50%;
}

.social-icons-wrapper > div {
  min-width: 33%;
}

.rectangels {
  background-color: #ebeff2;
  border-radius: 25px 25px 25px 0;
  min-height: 120px;
}

.rectangels:hover {
  cursor: pointer;
}

.rectangels-left:hover {
  cursor: pointer;
}

.rectangels-left {
  background-color: #ebeff2;
  border-radius: 25px 25px 0 25px;
  min-height: 120px;
}
.product-gif {
  filter: grayscale(100%) brightness(0.8);
  transition: filter 0.3s ease;
  background: transparent;
}

.menu-item:hover .product-gif,
.product-gif:hover {
  filter: brightness(0) invert(1);
}
.menu-item {
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
  /* width: 100%; */
}

.contained-game-modal ::v-deep .modal-content {
  max-height: 80vh;
  height: auto;
  max-width: 95vw;
}

.contained-game-modal ::v-deep .game-wrapper {
  max-height: calc(80vh - 100px); /* Adjust based on header height */
  overflow: hidden;
}
.card {
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  justify-items: center;
  align-items: center;
  justify-content: center;
}
.card-size-1 {
  /* min-height: 120px; */
}
.card-size-2 {
  /* min-height: 105px; */
}
.card-size-3 {
  min-height: 92px;
}
.card-size-4 {
  min-height: 50px;
  margin: 1px !important;
}
.card-size-5 {
  min-height: 50px;
  margin: 2px !important;
}

.product-gif {
  transition: all 0.25s ease;
  object-fit: contain;
}

.card-size-5 .product-gif,
.card-size-4 .product-gif {
  margin-bottom: 4px;
  width: 42px !important;
  height: 42px !important;
}

.card-size-5 p,
.card-size-4 p {
  font-size: 0.82rem !important;
  line-height: 1.2;
}
.card-size-1:hover,
.card-size-1:active {
  transform: scale(1.02) !important;
}
.card-size-2:hover,
.card-size-2:active {
  transform: scale(1.05) !important;
}

.card-size-3:hover,
.card-size-3:active {
  transform: scale(1.1) !important;
}
.card-size-4:hover,
.card-size-4:active {
  transform: scale(1.1) !important;
}
.card-size-5:hover,
.card-size-5:active {
  transform: scale(1.1) !important;
}
.modern-toggle-container {
  background: #f8f9fa;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: inline-block;
  transition: all 0.3s ease;
  position: absolute;
}

.custom-toggle-group {
  background-color: transparent !important;
}

.toggle-item {
  border-radius: 12px !important;
  background-color: white !important;
  border: 1px solid #e0e0e0 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.toggle-item:hover {
  border-color: #bdbdbd !important;
  background-color: #f5f5f5 !important;
}

.active-selection {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
}

.v-btn-toggle > .v-btn.v-btn {
  border-style: solid !important;
  opacity: 1;
}
.backdrop-blur {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.shadow-btn {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.sheet-handle {
  width: 40px;
  height: 4px;
  background: #e0e0e0;
  border-radius: 10px;
}

.size-toggle-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  background: transparent !important;
  width: 100%;
}

.size-btn-item {
  width: 60px !important;
  height: 60px !important;
  border-radius: 16px !important;
  background-color: #f5f5f5 !important;
  border: 2px solid transparent !important;
  transition: all 0.2s ease-in-out;
}

.size-active {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.shadow-sm {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.size-menu-wrapper {
  pointer-events: none; /* اجازه می‌ده کلیک از پشت رد بشه */
}

.size-menu-wrapper > * {
  pointer-events: auto;
}

.size-btn {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  font-size: 0.9rem !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
  padding: 0 16px !important;
  height: 42px !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12) !important;
  transition: all 0.25s ease;
}

.size-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16) !important;
}

.custom-toggle-group {
  background: transparent !important;
}

.toggle-item {
  border-radius: 50% !important;
  min-width: 38px !important;
  height: 38px !important;
  margin: 4px !important;
  font-weight: 600;
  border: 1px solid #e0e0e0 !important;
  transition: all 0.22s ease;
}

.toggle-item:hover {
  background-color: #f5f5f5 !important;
  border-color: #bdbdbd !important;
}

.active-selection {
  border: none !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22) !important;
}
.header-and-settings-wrapper {
  background: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.inner-settings-panel {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 16px;
  margin: 10px;
  position: relative;
  z-index: 1;
}
/* شبکه دکمه‌های کوچک */
.size-grid-internal {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  background: transparent !important;
  width: 100%;
  align-items: center;
  justify-items: center;
}

.size-mini-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  border-radius: 8px !important;
  background-color: #eee !important;
  font-size: 12px !important;
  font-weight: bold;
  transition: all 0.2s ease;
}

.shadow-btn {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15) !important;
}

.custom-scrollbar::-webkit-scrollbar {
  display: none;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
